/**
 * 财务审核批量车账单信息
 */
import React from 'react';
import messager from '../../ui/messager';
import { Input, Row, Col ,Select, Icon, Tooltip,DatePicker} from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth'


class BatchVehicleBillAuditIndex extends React.Component {

    columns = [ {
        title: '公司名称',
        dataIndex: 'projectId',
        width: '20%',
    }
    , {
        title: '月份',
        dataIndex: 'month',
        width: '6%',
    }
    , {
        title: '基础金额',
        dataIndex: 'amount',
        width: '8%'
    }
    ,{
        title: '调整金额',
        dataIndex: 'adjustAmount',
        width: '8%'
    }
    ,{
        title: '总金额',
        dataIndex: 'totalAmount',
        width: '8%',
    }
    ,{
        title: '账单备注',
        dataIndex: 'remark',
        width: '12%'
    }
    ,{
        title: '账单状态',
        dataIndex: 'status',
        width: '8%',
        format: { 0: '创建', 1: '已收费',2:'已审核' }
    }
    , {
        title: '创建时间',
        dataIndex: 'createTime',
        width: '10%',
    }
    , {
        title: '创建人',
        dataIndex: 'creator',
        width: '8%'
    }
    ,{
        title: '操作',
        dataIndex: 'id',
        width: '8%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("BARRIER_BATCH_VEHICLE_BILL_AUDIT")&&record.status === 1?
                <Tooltip title="收费审核">
                    <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.collectFees.bind(this, text)} style={{ color: '#008000' }} />
                </Tooltip>
                : ''}
            </div>
        )
    }
];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false,
        visible: false
    };

    //完成收费
    collectFees = (info, e) => {
        messager.confirm("是否完成该账单的审核？", () => {
            http.post({
                url: "/barrier/batchVehicleBill/status",
                data: { id: info, status: 2 },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("操作成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.projectId = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    queryMonthStart = (date, dateString) => {
        let { queryData } = this.state;
        queryData.month = dateString;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let { queryData } = this.state;
        queryData["status"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="公司名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 320 }}
                                />
                                <DatePicker.MonthPicker onChange={this.queryMonthStart} placeholder="月份" allowClear={false} style={{marginLeft: '10px' }} />
                                <Select onChange={this.selectChange} defaultActiveFirstOption allowClear={true} style={{ width: "150px", marginLeft: '10px' }}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="0">创建</Select.Option>
                                    <Select.Option value="1">已收费</Select.Option>
                                    <Select.Option value="2">已审核</Select.Option>
                                </Select>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/barrier/batchVehicleBill/page"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }
}

export default BatchVehicleBillAuditIndex;